<script setup lang="ts">
import {onMounted} from "vue";

defineOptions({
  name:'AppGtm'
})
onMounted(()=>{
  const func = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PR2GW79T');`;
  const script = document.createElement('script');
  script.innerHTML = func
  document.head.appendChild(script);


});
</script>

<template>
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PR2GW79T"  height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
</template>

<style scoped lang="scss">

</style>